import { isSupported as d, getMessaging as p, getToken as g } from "@firebase/messaging";
import { useAsync as u, useMountEffect as m } from "@react-hookz/web";
import { useMemo as o, useEffect as l, useCallback as c, useState as w } from "react";
import { isFirefox as b } from "react-device-detect";
import { u as v } from "./fallback-storage-value-DraZAU_d.mjs";
const N = () => {
  const [e, t] = u(async () => {
    const i = window !== void 0 && window.Notification !== void 0, s = await d();
    return !b && i && s;
  });
  return m(t.execute), {
    isNotificationSupported: e
  };
}, S = (e) => {
  const {
    isNotificationSupported: t
  } = N();
  return o(() => {
    if (t.result === !0 && e)
      return p(e);
  }, [e, t.result]);
}, L = (e) => {
  const t = S(e), [i, s] = u(async () => {
    if (!t) return;
    const r = await navigator.serviceWorker.ready;
    return g(t, {
      serviceWorkerRegistration: r
    });
  });
  return l(() => {
    t && s.execute();
  }, [s, t]), {
    refreshRegistrationToken: c(() => (s.reset(), s.execute()), [s]),
    registrationToken: i
  };
}, M = () => {
  const e = typeof window < "u" && window.Notification !== void 0, [t, i] = w(e ? window.Notification.permission : void 0), s = o(() => t === "granted", [t]), n = o(() => t === "denied", [t]), r = o(() => t === "default", [t]), f = c(async () => {
    if (!e) return;
    const a = await Notification.requestPermission();
    return i(a), a;
  }, [e]);
  return {
    isAvailable: e,
    isDenied: n,
    isGranted: s,
    isPrompt: r,
    permission: t,
    requestPermission: f
  };
}, P = () => {
  const {
    set: e,
    value: t
  } = v("subscriptedList");
  return {
    setSubscriptionList: e,
    subscriptionList: t
  };
};
export {
  S as a,
  L as b,
  M as c,
  P as d,
  N as u
};
//# sourceMappingURL=subscriptions-list-BFwNEEAv.mjs.map
